import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createBlockquoteBlock,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getFontSizeOptions } from "../../../utils/textStyleHelpers";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import placeholderImage from "./image_placeholder_1.png";
import starsPlaceholderImage from "./image_placeholder_stars.png";
import logoPlaceholderImage from "./logo_placeholder_elevate.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "TestimonialsBlock2",
  props: {
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    header: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: starsPlaceholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "7.25rem",
                width: "auto",
                height: "auto",
                minHeight: "none",
                minWidth: "none",
              },
            }),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createBlockquoteBlock({
          text: "“Clarity Coaching transformed my leadership approach. The guidance, support, and actionable insights helped me overcome self-doubt, enhance decision-making, and lead with confidence. The community and coaching sessions provided lasting value, shaping my career in ways I never imagined.”",
          styles: {
            fontSize: getFontSizeOptions("1.125rem"),
          },
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Emma Racheal",
          paragraphStyle: "p1",
        }),
        createPBlock({
          text: "Leadership Coach & Mentor @Elevate Coaching",
          paragraphStyle: "p3",
        }),
      ],
    },
    logo: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: logoPlaceholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "7.25rem",
                width: "auto",
                height: "auto",
                minHeight: "none",
                minWidth: "none",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: primaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
